module.exports = __webpack_public_path__ + "static/img/img-coupon.33f4fbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-coupon.png
// module id = XJPy
// module chunks = 1